import React from "react";

export default function GetStarted() {
  return (
    <div className=" bg-darkBlue py-28">
      <div className="mainContainer w-full lg:px-0 px-2 lg:w-7/12 flex justify-center mx-auto flex-col text-center">
        <h2 className="text-white text-4xl font-semibold">
          <span className="text-orange">Ready</span> to Get Started?
        </h2>
        <p className="text-white py-8">
          If you're a new client looking to broaden your horizons with Tomedes,
          here's your chance to partner with us. Contact us today, or get a free
          quote right now.
        </p>
        <div className="flex lg:flex-row flex-col lg:gap-y-0 gap-y-8 text-white mx-auto py-4 gap-x-8  ">
          <a
            href="/quote"
            className="rounded-full text-xs font-semibold px-5 py-3 flex justify-center items-center bg-orange hover:bg-[#ff9a16]"
          >
            TRANSLATE NOW
          </a>
          <a
            href="/contactus.php"
            className="rounded-full px-7 py-3 border text-xs font-semibold flex justify-center items-center border-white hover:bg-white hover:text-black"
          >
            CONTACT US
          </a>
        </div>
      </div>
    </div>
  );
}
